import React from 'react';
import EntityListRowForm from '../../../entities/entities-list/ui/EntitiesListRowForm/EntityListRowForm';
import { EntityServiceName } from '@api/enums/enums';
import EntitiesLoader from '../../../entities/EntitiesLoader/EntitiesLoader';
import { RoadInfrastructureEntityName } from '@api/types/types';

const RoadsList = () => {
    const roadEntityName = RoadInfrastructureEntityName.Road;
    const layerToReloadEntityName = RoadInfrastructureEntityName.RoadSegment; // segments should be deleted on road deletion
    const serviceName = EntityServiceName.ROAD_INFRASTRUCTURE;

    return (
        <EntitiesLoader
            entityName={roadEntityName}
            layerEntityName={layerToReloadEntityName}
            serviceName={serviceName}
            form={EntityListRowForm}
        />
    );
};

export default RoadsList;
